import { render, staticRenderFns } from "./CustomerListDialog.vue?vue&type=template&id=21fb7e2a&scoped=true"
import script from "./CustomerListDialog.vue?vue&type=script&lang=js"
export * from "./CustomerListDialog.vue?vue&type=script&lang=js"
import style0 from "./CustomerListDialog.vue?vue&type=style&index=0&id=21fb7e2a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fb7e2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21fb7e2a')) {
      api.createRecord('21fb7e2a', component.options)
    } else {
      api.reload('21fb7e2a', component.options)
    }
    module.hot.accept("./CustomerListDialog.vue?vue&type=template&id=21fb7e2a&scoped=true", function () {
      api.rerender('21fb7e2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialog/CustomerListDialog.vue"
export default component.exports